export const MAX_DATA_POINTS_WEB = 800;
export const MAX_DATA_POINTS_MOBILE = 100;
export const CHART_WIDTH_TO_TICKS_RATIO = 50;
